import React from 'react';
import PropTypes from 'prop-types';
import { Stepper } from 'sharedComponents/Stepper';
import './WizardStepper.scss';

/**
 * WizardStepper - Visual stepper component showing wizard progress
 * Uses the SharedComponents Stepper with wizard-specific adaptations
 * Supports error states for validation feedback
 */
const WizardStepper = ({
    steps = [],
    currentStepIndex = 0,
    onStepClick = () => { },
    orientation = 'horizontal',
    allowClickNavigation = true,
    className = '',
    errorSteps = [],
    disabledSteps = []
}) => {
    // Transform wizard steps to SharedComponents Stepper format
    const stepperSteps = steps.map(step => ({
        label: step.title,
        // description: step.description
    }));

    const handleStepChange = (stepIndex) => {
        if (allowClickNavigation) {
            // Allow navigation to any step for better UX
            onStepClick(stepIndex);
        }
    };

    return (
        <div className={`wizard-stepper ${className}`}>
            <Stepper
                steps={stepperSteps}
                activeStep={currentStepIndex}
                orientation={orientation}
                onChange={handleStepChange}
                disabled={!allowClickNavigation}
                errorSteps={errorSteps}
                disabledSteps={disabledSteps}
                className='wizard-stepper-component'
                stepClassName='wizard-step-item'
                connectorClassName='wizard-step-connector'
                completedStepClassName='wizard-completed-step'
                activeStepClassName='wizard-active-step'
                errorStepClassName='wizard-error-step'
                labelClassName='wizard-step-label'
            />
        </div>
    );
};

WizardStepper.propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string
        })
    ),
    currentStepIndex: PropTypes.number,
    onStepClick: PropTypes.func,
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
    allowClickNavigation: PropTypes.bool,
    className: PropTypes.string,
    errorSteps: PropTypes.arrayOf(PropTypes.number),
    disabledSteps: PropTypes.arrayOf(PropTypes.number)
};

// eslint-disable-next-line import/no-unused-modules
export default WizardStepper;
